import React, { FC, SVGProps } from 'react'

export const Heart4Svg: FC<
  { size?: number; color?: string } & SVGProps<SVGSVGElement>
> = ({ size = 24, color = '#2E2A29', ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M7.52259 19.0041C8.87332 19.8518 10.2748 20.8076 11.8658 20.9166V20.9166V20.9166C13.4568 20.8076 14.8583 19.8519 16.209 19.0042C18.5059 17.5626 21.91 14.819 22.259 11.0638C22.7891 5.3447 18.7394 4.2204 18.7394 4.2204C13.847 2.64801 12.2687 6.26333 11.8658 7.57831C11.463 6.26333 9.8846 2.64795 4.99222 4.22035C4.99222 4.22035 0.942552 5.34465 1.47265 11.0638C1.82163 14.8189 5.22576 17.5626 7.52259 19.0041Z"
      fill={color}
    />
  </svg>
)
